import { render, staticRenderFns } from "./depositList.vue?vue&type=template&id=8ec37ee4&scoped=true&lang=html"
import script from "./depositList.vue?vue&type=script&lang=js"
export * from "./depositList.vue?vue&type=script&lang=js"
import style0 from "./depositList.vue?vue&type=style&index=0&id=8ec37ee4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec37ee4",
  null
  
)

export default component.exports